// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1yJh9","title":"styles_title__3XNeF","text":"styles_text__3TJ2V"};